import styled from 'styled-components';
import { StyleColor, BaseStyledComponentProps, } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const driveItemRowImageSize = '150px';

interface ImageWrapperProps extends BaseStyledComponentProps {
	isActivated: boolean;
}

interface IconCheckProps extends BaseStyledComponentProps {
	isChecked: boolean;
}

const RowSvgWrapper = styled('span')`
	border-radius: 9px 0 0 9px;
	position: relative;
	background: ${(props: BaseStyledComponentProps) => props.theme.primary.cardColor};
	width: ${driveItemRowImageSize};
	height: ${driveItemRowImageSize};

	:before {
		content: "";
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 5)};
		border-radius: 9px 0 0 9px;
	}

	> svg {
		height: 60%;
		width: 60%;
		fill: ${StyleColor.Grey200};
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

const BlockWrapperStyle = `
	width: 100%;
	padding-top: 100%;
	height: 0;
	position: relative;
	text-align: center;
	overflow: hidden;
`;

const blockUnactiveBorder = (props: ImageWrapperProps) => `
	${!props.isActivated && `box-shadow: 0 9px 39px 1px rgba(0,0,0,0.1);` }
`;

const BlockSvgWrapper = styled('div')`
	${BlockWrapperStyle};
	background: ${(props: BaseStyledComponentProps) => props.theme.primary.cardColor};
	border-radius: 9px;
	${blockUnactiveBorder}

	:before {
		display: block;
		content: "";
		background-color: ${StyleColor.White};
		height: auto;
		width: 100%;
		border-radius: 9px;

	}

	& > svg {
		width: 39%;
		height: 39%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		fill: ${StyleColor.Grey200};
	}
`;

const GridImageWrapper = styled('div')`
	${BlockWrapperStyle};
	${blockUnactiveBorder}
	border-radius: 9px;
`;

const MasonryImageWrapper = styled('div')`
	width: 100%;
	height: auto;
	position: relative;
	border-radius: 9px;
	background-color: ${StyleColor.White};
	${blockUnactiveBorder}
`;

const RowImageWrapper = styled('span')`
	background-color: ${StyleColor.Grey100};
	border-radius: 9px 0 0 9px;
`;

const MasonryImage = styled('img')`
	width: 100%;
	min-height: 35px;
	height: auto;
	border-radius: 9px;
	vertical-align: middle;
`;

interface BackgroundImageProps {
	imgURL: string;
}

const backgroundImage = (props: BackgroundImageProps) => `
	background-image: url('${props.imgURL}');
	background-size: cover;
	background-position: 50% 50%;
`;

const RowBackgroundImage = styled('div')`
	border-radius: 9px 0 0 9px;
	width: ${driveItemRowImageSize};
	height: ${driveItemRowImageSize};
	flex-shrink: 0;
	${backgroundImage}
`;

const GridBackgroundImage = styled('div')`
	${backgroundImage}
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	height: 100%;
	border-radius: 9px;
`;

const IconCheck = styled('div')`
	box-sizing: border-box;
	position: absolute;
	bottom: 10px;
	left: 10px;
	width: 30px;
	height: 30px;
	color: ${({ theme }: IconCheckProps) => theme.primary.actionColor};
	border: 2px solid currentColor;
	border-radius: 50%;
	background-color: ${hexToRgba(StyleColor.White, 80)};

	${({ isChecked }: IconCheckProps) => isChecked && 'border: 0;'}

	svg {
		width: 100%;
		height: 100%;
		fill: currentColor;
	}
`;

export {
	GridImageWrapper,
	RowSvgWrapper,
	RowImageWrapper,
	RowBackgroundImage,
	BlockSvgWrapper,
	MasonryImage,
	MasonryImageWrapper,
	GridBackgroundImage,
	driveItemRowImageSize,
	IconCheck,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/Thumbnail/styles.ts